module.exports = __webpack_public_path__ + "static/media/mktools.04c61e68.png";